export default __webpack_public_path__ + "static/media/data_chart.4eab38ad.svg";